export default __webpack_public_path__ + "static/media/lisieux09.ba5c65ee.jpg";